import { Autocomplete, Stack, styled, TextField } from "@mui/material";
import React, { useState } from "react";
import { WHITE } from "../colors";
import { Grid } from "@mui/material";
import {FormControl,InputLabel,Select,MenuItem} from "@mui/material";


const CustomSelect = styled(Select)(({ theme }) => ({
  height: 42,
  minWidth: 312,
  backgroundColor: WHITE,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

const CustomTextField = styled(TextField)(({ theme }) => ({
  height: 42,
  minWidth: 312,
  backgroundColor: WHITE,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: 'transparent',
  },
  "&:focus-within": {
    border: 'transparent',
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: 'transparent',
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

const CustomAutoComplete = styled(Autocomplete)(({ theme }) => ({
  width: "100%",
  minWidth: 200,
  backgroundColor: WHITE,
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));
const domesticSearchOptions = [
  {
    value: 1,
    label: "Domestic",
  },
  {
    value: 0,
    label: "Non domestic",
  },
];
const InquirySearchContainer = ({ types, searchParams, setSearchParams }) => {
  const handleSearchChange = (event) => {
    setSearchParams({
      ...searchParams,
      searchTerm: event.target.value,
    });
  };

  const handleTypeChange = (event) => {
    setSearchParams({
      ...searchParams,
      type: event.target.value,
    });
  };

  return (
    <Stack direction="row" spacing={2}>
     
      <CustomTextField
        label="Search inquiries"
        // variant= 'standard'
        value={searchParams.searchTerm}
        onChange={handleSearchChange}
      />

      <FormControl variant="outlined">
       

      <CustomSelect
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={searchParams.type}
          onChange={handleTypeChange}
          label="Type"
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {types?.map((type) => (
            <MenuItem key={type.value} value={type.value}>
              {type.label}
            </MenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    </Stack>
  );
};


export default InquirySearchContainer;
